'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _redboxReact2 = require('redbox-react');

var _redboxReact3 = _interopRequireDefault(_redboxReact2);

var _react2 = require('react');

var _react3 = _interopRequireDefault(_react2);

var _reactTransformCatchErrors3 = require('react-transform-catch-errors');

var _reactTransformCatchErrors4 = _interopRequireDefault(_reactTransformCatchErrors3);

var _dec, _dec2, _class, _class2, _temp2;

var _reactCssModules = require('react-css-modules');

var _reactCssModules2 = _interopRequireDefault(_reactCssModules);

var _FeaturedTrips = require('./FeaturedTrips.scss');

var _FeaturedTrips2 = _interopRequireDefault(_FeaturedTrips);

var _reactIntl = require('react-intl');

var _Link = require('components/Link/Link');

var _Link2 = _interopRequireDefault(_Link);

var _SimilarTrip = require('components/TripDetail/SimilarTrip');

var _SimilarTrip2 = _interopRequireDefault(_SimilarTrip);

var _reactRedux = require('react-redux');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var _components = {
  FeaturedTrips: {
    displayName: 'FeaturedTrips'
  }
};

var _reactTransformCatchErrors2 = (0, _reactTransformCatchErrors4.default)({
  filename: '/home/runner/work/redux-frontend/redux-frontend/src/components/Home/FeaturedTrips.js',
  components: _components,
  locals: [],
  imports: [_react3.default, _redboxReact3.default]
});

function _wrapComponent(id) {
  return function (Component) {
    return _reactTransformCatchErrors2(Component, id);
  };
}

var FeaturedTrips = _wrapComponent('FeaturedTrips')((_dec = (0, _reactRedux.connect)(function (state) {
  return {
    locale: state.language.locale,
    siteConfigs: state.info.siteConfigs
  };
}), _dec2 = (0, _reactCssModules2.default)(_FeaturedTrips2.default), _dec(_class = _dec2(_class = (_temp2 = _class2 = function (_Component) {
  (0, _inherits3.default)(FeaturedTrips, _Component);

  function FeaturedTrips() {
    var _ref;

    var _temp, _this, _ret;

    (0, _classCallCheck3.default)(this, FeaturedTrips);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = FeaturedTrips.__proto__ || (0, _getPrototypeOf2.default)(FeaturedTrips)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
      limit: 3
    }, _this.showMore = function () {
      _this.setState({
        limit: _this.state.limit + 3
      });
    }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
  }

  (0, _createClass3.default)(FeaturedTrips, [{
    key: 'render',
    value: function render() {
      var _this2 = this;

      if (!this.props.featuredTrips || this.props.featuredTrips.length === 0) {
        return _react3.default.createElement('div', null);
      }
      var _props = this.props,
          homeStyle = _props.homeStyle,
          locale = _props.locale;

      var isMerge = homeStyle && locale === 'en' || false;
      return _react3.default.createElement(
        'div',
        { styleName: isMerge ? 'container-home' : 'container', style: { backgroundColor: this.props.bgColor } },
        _react3.default.createElement(
          'div',
          { styleName: 'inner' },
          !isMerge && _react3.default.createElement(
            'h2',
            { styleName: 'header' },
            _react3.default.createElement(_reactIntl.FormattedMessage, { id: 'home.featured_trips.header' })
          ),
          _react3.default.createElement(
            'div',
            { styleName: isMerge ? 'float-parent-home' : 'float-parent' },
            this.props.featuredTrips.map(function (trip, index) {
              if (index >= _this2.state.limit) {
                return false;
              }
              return _react3.default.createElement(
                'div',
                { styleName: 'float-item', key: index },
                _react3.default.createElement(_SimilarTrip2.default, { trip: trip, index: index })
              );
            })
          ),
          this.state.limit < this.props.featuredTrips.length && _react3.default.createElement(
            'div',
            { styleName: 'local-wrapper' },
            _react3.default.createElement(
              'button',
              { styleName: 'btn-all-ins', onClick: this.showMore },
              _react3.default.createElement(_reactIntl.FormattedMessage, { id: 'home.featured_trips.load_more' })
            )
          ),
          !(this.state.limit < this.props.featuredTrips.length) && this.props.siteConfigs.searchLinkFeaturedTrips && _react3.default.createElement(
            'div',
            { styleName: 'local-wrapper' },
            _react3.default.createElement(
              _Link2.default,
              { styleName: 'btn-all-ins', to: '/to/Bangkok' },
              _react3.default.createElement(_reactIntl.FormattedMessage, { id: 'home.featured_trips.load_more' })
            )
          )
        )
      );
    }
  }]);
  return FeaturedTrips;
}(_react2.Component), _class2.propTypes = {
  featuredTrips: _react2.PropTypes.array,
  locale: _react2.PropTypes.string,
  siteConfigs: _react2.PropTypes.object,
  bgColor: _react2.PropTypes.string,
  homeStyle: _react2.PropTypes.bool
}, _class2.defaultProps = {
  featuredTrips: [],
  bgColor: '#f2f2f2',
  homeStyle: false
}, _temp2)) || _class) || _class));

exports.default = FeaturedTrips;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/components/Home/FeaturedTrips.js
// module id = 1529
// module chunks = 47